import mapGetter from '@/mixins/getters.js'

export default{
    mixins:[mapGetter],
    data() {
        return {
            itemColumnHeaders: [
                {
                    field: 'id',
                    labelName: 'modal_ItemId',
                    sortable: true,
                    type: this.$store.getters.getColumnHeader.numeric,
                    translatable: false,
                    hidden: false,
                    isdisplayed:true,
                    order:1
                },
                {
                    field: 'description1',
                    labelName: 'modal_ItemDescr',
                    sortable: true,
                    type: this.$store.getters.getColumnHeader.text,
                    translatable: false,
                    hidden: false,
                    isdisplayed:true,
                    order:2
                },
                // {
                //     field: 'description2',
                //     labelName: 'modal_ItemDescr',
                //     sortable: true,
                //     type: this.$store.getters.getColumnHeader.text,
                //     translatable: false,
                //     hidden: false,
                //     isdisplayed:true,
                //     order:3
                // },
                {
                    field: 'departmentId',
                    labelName: 'modal_ItemDepartmentId',
                    sortable: true,
                    type: this.$store.getters.getColumnHeader.numeric,
                    translatable: false,
                    hidden: false,
                    isdisplayed:true,
                    isfilter : true,
                    order:4
                },
                {
                    field: 'plu1',
                    labelName: 'item_Plu1',
                    sortable: true,
                    type: this.$store.getters.getColumnHeader.text,
                    translatable: false,
                    hidden: false,
                    isdisplayed:true,
                    order:5
                },
                
            ],
        }
    },
    methods :{
        getItemColumnHeaders()
        {
            let colHeaders = this.$CObj(this.itemColumnHeaders)
            //Ajouter la traduction dans l'attribut label
            colHeaders.map(elem => {
                elem.label = (elem.labelName) ? this.$i18n.t(elem.labelName) : elem.field;
                return elem
            })
            .map(elem => {
                elem.thClass = elem.type.alignH
                elem.tdClass = elem.type.alignH
                elem.show    = !elem.hidden //Initialiser le champs show pour l'utiliser dans la liste des colonnes à afficher/ou pas
            })

            colHeaders = colHeaders.sort((p1,p2) => {
                if(p1.order < p2.order) return -1;
                if(p1.order > p2.order) return 1;
                return 0;
            });

            return colHeaders
        },
    },
    mounted() {
        
    },
    
    
}